'use client';
import Image from 'next/image';

import { StarRating } from '@/src/components/star-rating/StarRating';

type IReviewRatingProps = {
  note: number;
  platform: string;
  image: string;
  width: number;
  link: string;
  alt: string;
};

export const ReviewRating = ({
  note,
  platform,
  image,
  width,
  link,
  alt,
}: IReviewRatingProps) => {
  return (
    <div className={'space-y-1'}>
      <div className={'flex items-center gap-3.5'}>
        <p className={'text-2xl font-semibold'}>{note}</p>
        <StarRating rating={note} size={17} />
      </div>
      <p>{platform}</p>
      <Image
        className="cursor-pointer"
        src={image}
        width={width}
        height={40}
        onClick={() => {
          window.open(link, '_blank', 'noopener,noreferrer');
        }}
        alt={alt}
      />
    </div>
  );
};
